//引入平台级api
import api from "../api";
//引入平台级元数据
import "../metadata";
//引入平台使用的vuex的store
import store from "../store";
//注入平台全局过滤器
import filters from "../filters";
//注入平台全局自定义指令
import directives from "../directives";
//语言包
import i18n from "../i18n";
import dynamicComponent from "../mixins/common/dynamicComponent";
import * as mixins from "../mixins";

!(function (global) {
  //注册api
  api(dsf);
  dsf.mix(dsf, {
    dynamicComponent: dynamicComponent
  });
  if (!dsf.global.$mixins) {
    dsf.global.$mixins = {};
  }
  for (let k in mixins) {
    dsf.global.$mixins[k] = mixins[k];
  }
  dsf.mix(true, global.$i18n, { ...i18n });
  dsf.mix(true, global.$platformStore, { ...store });
  //注入全局指令和过滤器
  Vue.use(filters);
  Vue.use(directives);
})(dsf.global || (dsf.global = {}));
